<template>
  <div v-if="contactList">
    <!--Navigation Buttons-->
    <div class="button-group expanded">
      <a class="button hollow small" :class="{ 'disabled': !prevContact }" @click="goToNextContactOnList('prev')">
        <span class="fas fa-backward"></span>
      </a>
      <a class="button hollow small" @click="toggleShowContactsOnList()">{{ contactList.contacts_count }} on List</a>
      <a class="button hollow small" :class="{ 'disabled': !nextContact }" @click="goToNextContactOnList('next')">
        <span class="fas fa-forward"></span>
      </a>
    </div>

    <!--Contacts on List-->
    <div class="dropdown-pane padding-none" :class="{ 'is-open': showContactsOnList }">
      <ul class="list-navigator-list list-lined" v-if="contactsSlice">
        <li class="text-center" v-if="contactsSliceMeta.beforeSliceCount > 0">
          <em>
            <a @click="showFirstContacts = true">Previous {{ contactsSliceMeta.beforeSliceCount | number }} {{ contactsSliceMeta.beforeSliceCount > 1 ? 'contacts' : 'contact' }}</a>
          </em>
        </li>
        <li v-for="contact in contactsSlice" :key="contact.id" :class="{ 'active': contact.id === activeContact.id }">
          <a @click="goToContact(contact)">
            <div class="grid-x">
              <div class="cell auto">
                <salutation-name :contact="contact" />
              </div>
              <div class="cell shrink">
                <template v-if="contact.ask_amount">{{ contact.ask_amount | currency(true) }}</template>
              </div>
            </div>
          </a>
        </li>
        <li class="text-center" v-if="contactsSliceMeta.afterSliceCount > 0">
          <em>
            <a @click="showLastContacts = true">Next {{ contactsSliceMeta.afterSliceCount | number }} {{ contactsSliceMeta.afterSliceCount > 1 ? 'contacts' : 'contact' }}</a>
          </em>
        </li>
        <li class="text-center" v-if="showBackLink">
          <small>
            <a @click="goBackToList()">
              <span class="fas fa-chevron-left"></span> Back to List
            </a>
          </small>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import SalutationName from './SalutationName'

export default {
  components: { SalutationName },
  props: {
    activeContact: Object,
    contactList: Object,
    contacts: Array,
    showBackLink: Boolean
  },
  data () {
    return {
      showContactsOnList: false,
      showFirstContacts: false,
      showLastContacts: false
    }
  },
  computed: {
    prevContact () {
      return this.nextContactOnList('prev')
    },
    nextContact () {
      return this.nextContactOnList('next')
    },
    contactsSliceMeta () {
      if (!this.contacts) {
        return []
      }
      // get the index of the current contact
      const currentIndex = this.contacts.findIndex(contact => contact.id === this.activeContact.id)
      const maxIndex = this.contacts.length
      // get a few before and after
      let startIndex = currentIndex - 4
      startIndex = startIndex >= maxIndex ? maxIndex - 1 : startIndex
      startIndex = startIndex < 0 ? 0 : startIndex
      let endIndex = currentIndex + 10
      endIndex = endIndex < startIndex ? startIndex : endIndex
      endIndex = endIndex > maxIndex ? maxIndex : endIndex
      // override the indices if the user has requested it
      if (this.showFirstContacts) {
        startIndex = 0
      }
      if (this.showLastContacts) {
        endIndex = maxIndex
      }
      return {
        startIndex,
        endIndex,
        beforeSliceCount: startIndex,
        afterSliceCount: maxIndex - endIndex
      }
    },
    contactsSlice () {
      if (!this.contactsSliceMeta || !this.contacts) {
        return null
      }
      return this.contacts.slice(this.contactsSliceMeta.startIndex, this.contactsSliceMeta.endIndex)
    }
  },
  methods: {
    toggleShowContactsOnList (forceClose) {
      // hide the prev/next contacts
      this.showFirstContacts = false
      this.showLastContacts = false
      // toggle the view
      this.showContactsOnList = forceClose ? false : !this.showContactsOnList
    },
    nextContactOnList (prevOrNext) {
      if (!this.activeContact || !this.contacts) {
        return null
      }
      const currentIndex = this.contacts.findIndex(contact => contact.id === this.activeContact.id)
      const nextIndex = prevOrNext === 'prev' ? currentIndex - 1 : currentIndex + 1
      // return the next item or null
      return this.contacts[nextIndex] ? this.contacts[nextIndex] : null
    },
    goToNextContactOnList (prevOrNext) {
      const contact = this.nextContactOnList(prevOrNext)
      if (!contact) {
        return
      }
      return this.goToContact(contact)
    },
    goToContact (contact) {
      this.$emit('goToContact', contact.id)
      this.toggleShowContactsOnList(true)
    },
    goBackToList () {
      this.$emit('goBackToList')
    }
  }
}
</script>

<style lang="scss">
@import "../../style/settings";

.list-navigator-list {
  margin-bottom: 0;
  li.active {
    background: $highlight-background-color;
    font-weight: 600;
  }
}
</style>
